An optional free-text billing reference.

This appears on the invoice when SEEK bills the hirer for the job ad.

This field has a maximum length of 50 characters.
